<div id="ssoMenu">
  <div
    nz-dropdown
    *ngIf="modelManagementLink || oneAccessLink"
    [nzDropdownMenu]="menu"
    nzPlacement="bottomRight"
    nzTrigger="click"
  >
    <va-icon
      isFontAwesome="true"
      [name]="faCaretCircleDown"
      class="fa-lg right-icon"
    ></va-icon>
    <span class="header-menu-text user-name">Insights</span>
  </div>
  <nz-dropdown-menu #menu="nzDropdownMenu">
    <ul nz-menu class="sso-menu-list">
      <li class="logo-item">
        <img
          class="VA_logo"
          src="{{
            assetUrl
          }}/VisibleAlpha_horizontal_spg_pos_rgb_no-padding.svg"
          alt="Visible Alpha now a part of S&P Global Market Intelligence"
        />
      </li>
      <li nz-menu-item><b>Insights</b></li>
      <li nz-menu-item *ngIf="modelManagementLink != ''">
        <a href="{{ modelManagementLink }}">Model Management</a>
      </li>
      <li nz-menu-item *ngIf="oneAccessLink != ''">
        <a href="{{ oneAccessLink }}">Interactions (ONEaccess)</a>
      </li>
    </ul>
  </nz-dropdown-menu>
</div>
